import HIGHLIGHTED_CHIP_CLASS_NAME, { GRAY_DELETABLE_CHIP_CLASS_NAME } from '../../constants/chip';

export const highlightedChipStyles = ({ theme, backgroundColor }) => ({
  backgroundColor,
  color: theme.palette.common.white,
  fontWeight: 600,
  '& .MuiChip-icon': {
    color: theme.palette.common.white,
  },
});

const grayDeletableChipStyles = ({ theme }) => ({
  borderRadius: 4,
  backgroundColor: theme.palette.gray.A100,
  color: theme.palette.text.primary,
  '& .MuiChip-deleteIcon': {
    color: theme.palette.primary.main,
    fontSize: 18,
  },
});

const MuiChip = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${HIGHLIGHTED_CHIP_CLASS_NAME}`]: highlightedChipStyles({ theme, backgroundColor: theme.palette.primary.main }),
      [`&.${GRAY_DELETABLE_CHIP_CLASS_NAME}`]: grayDeletableChipStyles({ theme }),
    }),
  },
};

export default MuiChip;
